'use client';
import { Button } from '@common/components';
import { useClipboard } from '@common/hooks';
import { SvgShare2 } from '@common/icon';
import { cn } from '@core/utils';
import { useSuspenseQuery } from '@tanstack/react-query';
import { motion } from 'framer-motion';
import Link from 'next/link';

import { UnauthQueryOptions } from '@/api';
import { ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';

const CONTAINER_VARIANTS = {
  hidden: {
    y: 100,
    opacity: 0,
  },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      type: 'spring',
      stiffness: 260,
      damping: 20,
      staggerChildren: 0.05,
    },
  },
};

const BUTTON_VARIANTS = {
  hidden: { opacity: 0, scale: 0.95 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.3,
    },
  },
};

export const BottomSection = () => {
  const copy = useClipboard();
  const router = useCustomRouter();

  const { data } = useSuspenseQuery({
    ...UnauthQueryOptions[
      'get:/wello/v2/allows/local-festa/institution-specialty'
    ](),
    select: ({ context }) => context,
  });

  const isEntry = !!data?.entryYN;

  const handleShareClick = () => {
    // app. 서브도메인을 www.로 변환하여 복사
    const url = window.location.href.replace(/^(https?:\/\/)app\./, '$1www.');
    copy({ value: url });
  };

  const handleApply = () => {
    router.push(ROUTES.LOCALFESTA_APPLY.pathname);
  };

  return (
    <footer className="sticky bottom-0 z-50 mt-auto w-full">
      <motion.div
        className="flex w-full items-center gap-8 bg-Gray-black/25 px-20 py-12 backdrop-blur-md"
        variants={CONTAINER_VARIANTS}
        initial="hidden"
        animate="visible"
      >
        <motion.div className="flex-1" variants={BUTTON_VARIANTS}>
          <motion.div
            {...(isEntry && {
              whileHover: { scale: 1.02, y: -2 },
              whileTap: { scale: 0.98 },
              transition: { type: 'spring', stiffness: 400, damping: 17 },
            })}
          >
            <Button
              dimensions="H48"
              theme="secondary-fill"
              className={cn('w-full', !isEntry && '!bg-Gray-300 !opacity-90')}
              disabled={!isEntry}
              onClick={handleApply}
            >
              참가 신청
            </Button>
          </motion.div>
        </motion.div>

        <motion.div className="flex-1" variants={BUTTON_VARIANTS}>
          <motion.div
            whileHover={{ scale: 1.02, y: -2 }}
            whileTap={{ scale: 0.98 }}
            transition={{ type: 'spring', stiffness: 400, damping: 17 }}
          >
            <Button
              asChild
              dimensions="H48"
              theme="sub-fill"
              className="w-full"
            >
              <Link href={ROUTES.LOCALFESTA_APPLY.pathname}>신청 조회</Link>
            </Button>
          </motion.div>
        </motion.div>

        <motion.div variants={BUTTON_VARIANTS}>
          <motion.div
            whileHover={{ scale: 1.1, rotate: 5 }}
            whileTap={{ scale: 0.9 }}
            transition={{ type: 'spring', stiffness: 400, damping: 17 }}
          >
            <Button
              className="-mx-8 bg-transparent"
              theme="sub-text"
              dimensions="H40"
              onClick={handleShareClick}
            >
              <SvgShare2 className="size-20 text-Gray-white" />
            </Button>
          </motion.div>
        </motion.div>
      </motion.div>
    </footer>
  );
};
